import React, { useState } from 'react';
import { WORKFLOW_ICON_URL, publicAssetUrl } from '../../../utils/publicAssetUrl';

const LOGO_FALLBACK = publicAssetUrl('assets/logo/logo-oficial.png');

export interface DataFlowWordmarkProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function DataFlowWordmark({ size = 'md', className = '' }: DataFlowWordmarkProps) {
  const [iconSrc, setIconSrc] = useState(WORKFLOW_ICON_URL);
  const iconSize = size === 'sm' ? 'h-7 w-7' : size === 'lg' ? 'h-9 w-9' : 'h-8 w-8';
  const textSize = size === 'sm' ? '1.05rem' : size === 'lg' ? '1.35rem' : '1.2rem';

  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`.trim()}>
      <img
        src={iconSrc}
        alt="DataFlow"
        className={`${iconSize} shrink-0 rounded-full object-cover`}
        loading="eager"
        decoding="async"
        onError={() => {
          if (iconSrc !== LOGO_FALLBACK) setIconSrc(LOGO_FALLBACK);
        }}
      />
      <span className="inline-flex items-center tracking-tight leading-none">
        <span style={{ fontWeight: 900, fontSize: textSize, color: '#0f172a', letterSpacing: '-0.02em' }}>DATA</span>
        <span style={{ fontWeight: 500, fontSize: textSize, color: '#2563eb', letterSpacing: '-0.02em' }}>FLOW</span>
      </span>
    </span>
  );
}
